<mat-tab-group
  [contentTabIndex]="attribute?.contentTabIndex"
  [disablePagination]="attribute?.disablePagination"
  [disableRipple]="attribute?.disableRipple"
  [dynamicHeight]="attribute?.dynamicHeight"
  [headerPosition]="attribute?.headerPosition"
  [selectedIndex]="attribute?.selectedIndex"
  [ngClass]="attribute?.className ? attribute?.className : ''"
  (selectedTabChange)="tabChanged($event, tabObject)"
  class="dg-appgen-tab dg-ag-common"
>
  <ng-container *ngFor="let tab of tabData">
    <mat-tab
      [label]="tab.attribute.label"
      [id]="'comp' + tab?.fieldId"
      *ngIf="!tab?.attribute?.hideShow"
      [disabled]="tab?.attribute?.enableDisable ? true : false"
    >
      <!--
         [ngClass]="tab?.attribute?.hideShow ? 'd-none' : 'd-block'"
        <ng-template>
    <p class="parent-main-title">{{ tab.label }}</p>
  </ng-template> -->
      <ng-container *ngFor="let data of tab.children">
        <ng-container [ngSwitch]="true">
          <app-app-gen-tab
            *ngSwitchCase="data.fieldType == 102"
            [tabData]="data.children"
            [attribute]="data.attribute"
            [eventId]="eventId"
            (appGenDataEmit)="appGenDataEmitFromTab($event)"
          ></app-app-gen-tab>
          <app-app-gen-stepper
            *ngSwitchCase="data.fieldType == 97"
            [stepData]="data.children"
            [attribute]="data.attribute"
            [eventId]="eventId"
          ></app-app-gen-stepper>
          <app-app-gen-expansionpanel
            *ngSwitchCase="data.fieldType == 93"
            [expansionData]="data.children"
            [attribute]="data.attribute"
            [eventId]="eventId"
          ></app-app-gen-expansionpanel>
          <app-gen-checklist
            *ngSwitchCase="data.fieldType == 107"
            [checklistData]="data"
            [attribute]="data.attribute"
            [eventId]="eventId"
            (appGenDataEmit)="appGenDataEmitFromCheckList($event)"
          ></app-gen-checklist>
          <app-app-gen-card
            *ngSwitchCase="data.fieldType == 89"
            [cardData]="data"
            [eventId]="eventId"
          >
          </app-app-gen-card>
          <app-gen-column
            *ngSwitchCase="data.fieldType == 106"
            [columnData]="data.children"
            [attribute]="data.attribute"
            [eventId]="eventId"
          ></app-gen-column>
          <app-common
            *ngSwitchCase="
              data.fieldType == 51 ||
              data.fieldType == 12 ||
              data.fieldType == 23 ||
              data.fieldType == 25 ||
              data.fieldType == 24 ||
              data.fieldType == 40 ||
              data.fieldType == 71 ||
              data.fieldType == 74 ||
              data.fieldType == 79 ||
              data.fieldType == 81 ||
              data.fieldType == 83 ||
              data.fieldType == 87 ||
              data.fieldType == 90 ||
              data.fieldType == 91 ||
              data.fieldType == 92 ||
              data.fieldType == 99 ||
              data.fieldType == 100 ||
              data.fieldType == 103 ||
              data.fieldType == 104 ||
              data.fieldType == 105 ||
              data.fieldType == 108 ||
              data.fieldType == 111 ||
              data.fieldType == 16
            "
            [res]="data"
            [formId]="FORMID"
            [tid]="tid"
            (emitTransId)="getTransId($event)"
            [ngClass]="data.fieldType == 99 ? 'AppGen-button' : ''"
            (appGenDataEmit)="appGenDataFromCommon($event)"
          >
          </app-common>

          <ng-container *ngIf="eventId == 23">
            <ng-container *ngSwitchDefault>
              <dg-dynamic-input
                *ngIf="!data.attribute.hideShow"
                [id]="'comp' + data.attribute.fieldId"
                [data]="data.attribute"
                [value]="data?.defaultValue"
                [showLabel]="showLabel"
                [dataPropConfig]="inputDataPropConfig"
                [comboPropConfig]="comboPropConfig"
                [form]="commonService.appGenFormGroup"
                [ngClass]="
                  data.attribute.className
                    ? data.attribute.className
                    : 'appgen-w-35'
                "
                class="dg-appgen-dynamic-input"
                (onChangeEvent)="onInputChange(data, 'onChange')"
                (onBlurEvent)="onInputChange(data, 'onBlur')"
                (onSearchClick)="onInputChange(data, 'search')"
                (keypress)="onKeyPress($event)"
              >
              </dg-dynamic-input>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="eventId != 23">
            <ng-container *ngSwitchDefault>
              <dg-dynamic-input
                *ngIf="!data.attribute.hideShow"
                [id]="'comp' + data.attribute.fieldId"
                [data]="data.attribute"
                [value]="data?.attribute.defaultValue"
                [showLabel]="showLabel"
                [dataPropConfig]="inputDataPropConfig"
                [comboPropConfig]="comboPropConfig"
                [form]="commonService.appGenFormGroup"
                [ngClass]="
                  data.attribute.className
                    ? data.attribute.className
                    : 'appgen-w-35'
                "
                class="dg-appgen-dynamic-input"
                (onChangeEvent)="onInputChange(data, 'onChange')"
                (onBlurEvent)="onInputChange(data, 'onBlur')"
                (onSearchClick)="onInputChange(data, 'search')"
                (keypress)="onKeyPress($event)"
              >
              </dg-dynamic-input>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>

      <div *ngIf="!tabButton" class="AppGen-button next-previous-btn">
        <button
          *ngIf="
            tabData.length - tabLength.length > 1 && attribute.selectedIndex > 0
          "
          mat-raised-button
          color="primary"
          (click)="onPrev()"
          class="me-2"
        >
          Previous
        </button>

        <button
          mat-raised-button
          color="primary"
          (click)="onNext()"
          [ngClass]="!commonService.nextTab ? '' : 'd-none'"
        >
          Next
        </button>
      </div>
    </mat-tab>
  </ng-container>
</mat-tab-group>
